<script setup>
// Props
defineProps({ dependencies: { type: Array, default: () => [] }, message: { type: String, default: null } })

// Constants
const { t, te } = useI18n({ useScope: 'global' })

// Methods
const serviceLabel = (service) => {
  const key = 'Shared.Globals.' + service.charAt(0).toUpperCase() + service.slice(1)
  return te(key) ? t(key) : service
}
</script>

<template>
  <!-- Blocking relations -->
  <q-banner v-if="dependencies.length" class="bg-orange-1 text-dark q-mb-md" rounded role="alert">
    <div class="text-weight-medium">{{ t('Shared.Globals.Delete dependencies') }}</div>
    <p v-if="message" class="q-my-xs">{{ message }}</p>
    <ul class="q-my-xs q-pl-md">
      <li v-for="dependency in dependencies" :key="dependency.service">{{ serviceLabel(dependency.service) }}: {{ dependency.count }}</li>
    </ul>
  </q-banner>
</template>
